export default {
  getApplicationUser(state) {
    return state.applicationUser
  },
}